export default __webpack_public_path__ + "static/media/80078967.10b1d7b3.png";